import { FilterButton } from './filter-button.class';

export class TopFilterButton extends FilterButton {

    preSelected = false;

    constructor(
        id: string,
        label: string,
        icon: string,
        ariaLabel: string,
        facets: Array<any>,
        preSelected?: boolean
    ) {
        super(id, label, icon, ariaLabel, facets);
        this.preSelected = preSelected;
    }

    setSelectedState() {
        this.selected = this.facets.every(f => f.value);
        this.selectedSg.set(this.selected);
    }
}
